import axios from 'axios';
import { messageManager } from '../utils/messageManager';

// const baseURL = process.env.REACT_APP_SERVICE_API_URL
const api = axios.create({

  baseURL: "/service-api",
  // baseURL: 'http://localhost:8000',
  // baseURL: 'http://192.168.77.176:8000',
});

// Генератор уникальных ID для запросов
let requestIdCounter = 0;
const generateRequestId = () => {
  return `request_${Date.now()}_${++requestIdCounter}`;
};

// Функция для определения, нужно ли показывать уведомления для этого запроса
const shouldShowNotifications = (config) => {
  // Не показываем уведомления для запросов с параметром silent
  if (config.silent === true) {
    return false;
  }

  // Не показываем для refresh token
  if (config.url?.includes('/auth/refresh')) {
    return false;
  }

  // Не показываем для GET запросов по умолчанию (можно настроить)
  // if (config.method === 'get' && !config.showNotifications) {
  //   return false;
  // }

  return true;
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Добавляем уникальный ID запроса
  if (shouldShowNotifications(config)) {
    config.requestId = generateRequestId();

    // Определяем сообщение для loading
    const loadingMessage = config.loadingMessage || 'Загрузка...';
    messageManager.showLoading(config.requestId, loadingMessage);
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

api.interceptors.response.use(
  (response) => {
    const config = response.config;

    // Проверяем нужно ли показывать уведомления
    if (shouldShowNotifications(config) && config.requestId) {
      // Проверяем code в response.data
      const responseData = response.data;
      const code = responseData?.code;

      if (code && code !== 200) {
        // Ошибка с кодом в ответе (например, code: 400)
        const errorMessage = responseData?.description ||
          responseData?.message ||
          `Ошибка: ${code}`;
        messageManager.showError(config.requestId, errorMessage);
      } else {
        // Успешный ответ
        const successMessage = config.successMessage ||
          responseData?.message ||
          'Успешно выполнено';
        messageManager.showSuccess(config.requestId, successMessage);
      }
    }

    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Показываем ошибку для запросов с уведомлениями
    if (shouldShowNotifications(originalRequest) && originalRequest.requestId) {
      // Проверяем, есть ли code в error.response.data
      const responseData = error.response?.data;
      const code = responseData?.code;

      let errorMessage = 'Произошла ошибка';

      if (code) {
        errorMessage = responseData?.description ||
          responseData?.message ||
          `Ошибка: ${code}`;
      } else if (error.response?.status) {
        errorMessage = responseData?.message ||
          responseData?.description ||
          `Ошибка ${error.response.status}`;
      } else if (error.message) {
        errorMessage = error.message;
      }

      // Не показываем ошибку для 401 (будет refresh)
      if (error.response?.status !== 401) {
        messageManager.showError(originalRequest.requestId, errorMessage);
      }
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) throw new Error('No refresh token');

        const response = await api.post('/auth/refresh', {
          refresh_token: refreshToken,
          silent: true // Не показываем уведомления для refresh
        });

        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);

        originalRequest.headers.Authorization = `Bearer ${response.data.access_token}`;
        return api(originalRequest);
      } catch (refreshError) {
        console.error('Refresh token failed:', refreshError);
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_role');
        // window.location.href = '/service/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;